import React from 'react';

import {
  Box,
  Button
} from '@mui/material';

import { MessageDataModal } from 'modules';
import { data } from './data';



export type ChartTestActivityProps = {};

export const ChartTestActivity = (props: ChartTestActivityProps) => {
  const [
    isPbvVisible,
    setIsPbvVisible
  ] = React.useState(false);

  const [
    isMarketCapVisible,
    setIsMarketCapVisible
  ] = React.useState(false);

  const [
    isDividendYieldVisible,
    setIsDividendYieldVisible
  ] = React.useState(false);

  const [
    isRepOfCommonEquityVisible,
    setIsRepOfCommonEquityVisible
  ] = React.useState(false);

  const [
    isOperatingMarginVisible,
    setIsOperatingMarginVisible
  ] = React.useState(false);

  const [
    isEbitdaGrowthVisible,
    setIsEbitdaGrowthVisible
  ] = React.useState(false);

  const [
    isNetIncomeVisible,
    setIsNetIncomeVisible
  ] = React.useState(false);

  const [
    isAccountReceivableVisible,
    setIsAccountReceivableVisible
  ] = React.useState(false);

  const [
    isAltmanZScoreVisible,
    setIsAltmanZScoreVisible
  ] = React.useState(false);

  const [
    isCurrentRatioVisible,
    setIsCurrentRatioVisible
  ] = React.useState(false);

  return (
    <Box>
      <Box sx={{
        mb: 4, display: 'flex', flexWrap: 'wrap', gap: 4, padding: 4
      }}
      >
        <Button
          variant='contained'
          onClick={() => setIsPbvVisible(true)}
        >
          Show P/BV
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsMarketCapVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show Market Capitalization
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsDividendYieldVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show Dividend Yield
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsRepOfCommonEquityVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show Repurchase of Common Equity
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsOperatingMarginVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show Operating Margin
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsEbitdaGrowthVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show EBITDA Growth
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsNetIncomeVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show Net Income Growth
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsAccountReceivableVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show Account Receivable
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsAltmanZScoreVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show Altman Z-Score
        </Button>
        <Button
          variant='contained'
          onClick={() => setIsCurrentRatioVisible(true)}
          sx={{
            mr: 2
          }}
        >
          Show Current Ratio
        </Button>
      </Box>

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isPbvVisible}
        data={data.pbv}
        handleClose={() => setIsPbvVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isMarketCapVisible}
        data={data.marketCap}
        handleClose={() => setIsMarketCapVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isDividendYieldVisible}
        data={data.dividendYield}
        handleClose={() => setIsDividendYieldVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isRepOfCommonEquityVisible}
        data={data.repOfCommonEquity}
        handleClose={() => setIsRepOfCommonEquityVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isOperatingMarginVisible}
        data={data.operatingMargin}
        handleClose={() => setIsOperatingMarginVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isEbitdaGrowthVisible}
        data={data.ebitdaGrowth}
        handleClose={() => setIsEbitdaGrowthVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isNetIncomeVisible}
        data={data.netIncomeGrowth}
        handleClose={() => setIsNetIncomeVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isAccountReceivableVisible}
        data={data.accountReceivable}
        handleClose={() => setIsAccountReceivableVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isAltmanZScoreVisible}
        data={data.altmanZScore}
        handleClose={() => setIsAltmanZScoreVisible(false)}
      />

      <MessageDataModal.FC
        ticker='AAPL'
        isVisible={isCurrentRatioVisible}
        data={data.currentRatio}
        handleClose={() => setIsCurrentRatioVisible(false)}
      />
    </Box>
  );
};
